// extracted by mini-css-extract-plugin
export default {"root":"UploadFile_root__cYGhS","wrapper":"UploadFile_wrapper__nLCIl","dropZone":"UploadFile_dropZone__bcoNG"};